import AddAccount from "./addAccount"
import AddAccountDark from "./addAccountDark"
import AlertTransactionEdit from "./alertTransactionEdit"
import AlertTriangleError from "./AlertTriangleError"
import Americanexpress from "./Americanexpress"
import Analytics from "./analytics"
import Archive from "./archive"
import ArrowCornerDownRight from "./arrowCornerDownRight"
import ArrowInbox from "./arrowInbox"
import ArrowLeft from "./arrowLeft"
import ArrowLeft2 from "./arrowLeft2"
import ArrowOutOfBox from "./arrowOutOfBox"
import ArrowRight from "./arrowRight"
import ArrowRisk from "./arrowRisk"
import ArrowRotate from "./arrowRotate"
import Arrows from "./arrows"
import ArrowsCircle from "./arrows-circle"
import ArrowSelectDown from "./ArrowSelectDown"
import ArrowSelectDownMobile from "./ArrowSelectDownMobile"
import ArrowShareRight from "./arrowShareRight"
import ArrowsRepeat from "./arrowsRepeat"
import ArrowsRotate from "./arrowsRotate"
import Bank from "./bank"
import BarChart from "./barChart"
import Bell from "./bell"
import BellAlarm from "./BellAlarm"
import BulletList from "./bulletList"
import Business from "./business"
import BankCard from "./business-health/bankCard"
import BhMetricChargeback from "./business-health/bh_metric_chargeback"
import BhMetricPayment from "./business-health/bh_metric_payment"
import BhMetricThreeDs from "./business-health/bh_metric_three_ds"
import BhMetricVolume from "./business-health/bh_metric_volume"
import BhVampCheck from "./business-health/bh_vamp_check"
import BhVampClock from "./business-health/bh_vamp_clock"
import BhVampError from "./business-health/bh_vamp_error"
import BhVampFlag from "./business-health/bh_vamp_flag"
import BhVampLock from "./business-health/bh_vamp_lock"
import BhVampQuestionMark from "./business-health/bh_vamp_question_mark"
import CalendarClock from "./calendarClock"
import CalendarDays from "./calendarDays"
import Camera from "./camera"
import Card from "./card"
import CartUpcoming from "./CartUpcoming"
import ChargeBy from "./chargeBy"
import Check from "./check"
import CheckFull from "./checkFull"
import ChecklistBell from "./checklistBell"
import CheckMark from "./checkMark"
import CheckMarkblue from "./checkMarkblue"
import CheckSimple from "./checkSimple"
import ChevronDown from "./chevronDown"
import ChevronDownFull from "./chevronDownFull"
import ChevronDownSmall from "./chevronDownSmall"
import ChevronLeftSmall from "./chevronLeftSmall"
import ChevronRightSmall from "./chevronRightSmall"
import CircleCheck from "./circleCheck"
import CircleCheckGreen from "./circleCheckGreen"
import CircleClose from "./circleClose"
import CircleInfo from "./circleInfo"
import CircleInfoSimple from "./circleInfoSimple"
import CircleInfoStrong from "./circleInfoStrong"
import CircleOutlinedInfo from "./circleOutlinedInfo"
import CirclePlaceholderDashed from "./circlePlaceholderDashed"
import CirclePlusDashed from "./circlePlusDashed"
import CircleX from "./circleX"
import Clock from "./clock"
import ClockAlert from "./clockAlert"
import ClockFilled from "./clockFilled"
import ClockOutlinedBold from "./clockOutlinedBold"
import CloseModal from "./closeModal"
import CodeLines from "./codeLines"
import ColorPalette from "./colorPalette"
import Comment from "./comment"
import Compare from "./compare"
import ConnectStripe from "./connectStripe"
import Contrast from "./contrast"
import Copy from "./copy"
import CopyRevert from "./copy_revert"
import CreditCard from "./creditCard"
import CrossSmall from "./crossSmall"
import Customers from "./customers"
import Delete from "./delete"
import Discover from "./Discover"
import Document from "./document"
import Edit from "./Edit"
import EditBig from "./editBig"
import EditBig2 from "./editBig2"
import EditSmall from "./editSmall"
import Email from "./email"
import EmailLarge from "./emailLarge"
import EmailNotification from "./emailNotification"
import EmptyWarning from "./empty-warning"
import Enlarge from "./enlarge"
import ErrorFull from "./errorFull"
//Modal
import ExclamationMarkModal from "./exclamationMarkModal"
import Eye from "./Eye"
import EyeInvisible from "./EyeInvisible"
import EyeSparkle from "./eyeSparkle"
import Faq from "./Faq"
import FileDownload from "./fileDownload"
import { Focus } from "./focus"
import FullScreen from "./fullScreen"
import Gift from "./Gift"
import Globus from "./globus"
import Grab from "./grab"
import Grid from "./grid"
import Hashtag from "./hashtag"
import HeartBeat from "./heartBeat"
import HelpModalError from "./help-modal-error"
//Header
import Home from "./home"
import HourGlassGray from "./hour-glass-gray.js"
import HourGlass from "./hourGlass"
// How did you find us form
import BookmarkCheck from "./how-did-you-find-us/bookmarkCheck"
import Fistbump from "./how-did-you-find-us/fistbump"
import Globe from "./how-did-you-find-us/globe"
import Heart from "./how-did-you-find-us/heart"
import MagicStick from "./how-did-you-find-us/magicStick"
import Newspaper from "./how-did-you-find-us/newspaper"
import SearchFindUsForm from "./how-did-you-find-us/search"
import SettingsGear from "./how-did-you-find-us/settingsGear"
import Store from "./how-did-you-find-us/store"
import Trophy from "./how-did-you-find-us/trophy"
import Idea from "./idea"
import InboxEmpty from "./inboxEmpty"
import InboxEmptyFilled from "./inboxEmptyFilled"
import InfoBanner from "./infoBanner"
import InfoBubble from "./infoBubble"
import InfoBubbleEmpty from "./infoBubbleEmpty"
import InfoMarkModal from "./infoMarkModal"
import LayoutAlignRight from "./layoutAlignRight"
import Link from "./link"
import CardsView from "./list-view-icons/cardsView"
import TableView from "./list-view-icons/tableView"
import ListSparkle from "./listSparkle"
import Loader from "./loader"
import Lock from "./lock"
import LockBlue from "./lockBlue.js"
import Logo from "./logo"
import LogoSimple from "./LogoSimple"
import Logout from "./logout"
import Mastercard from "./mastercard"
import MastercardLogoDark from "./mastercard"
import MastercardLogo from "./mastercardLogo"
import Medal1 from "./medal_1"
import Medal2 from "./medal_2"
import Medal3 from "./medal_3"
import Menu from "./menu"
import MenuSearch from "./menuSearch"
import Message from "./message"
import Messages from "./messages"
import Minus from "./minus"
import MobileSideBar from "./MobileSideBar"
import MobileVideoCourse from "./MobileVideoCourse"
import CircleQuestion from "./modal/circleQuestion"
import ConfirmDeleteModal from "./modal/confirmDelete"
import InfoWarningBig from "./modal/infoWarningBig"
import SuccessModal from "./modal/success"
import Money from "./money"
import { Money2 } from "./money2"
import MoneyHand from "./moneyHand"
import Moon from "./moon"
import MultiMedia from "./multiMedia"
import { Navigation } from "./navigation"
import NoDataAvailable from "./noDataAvailable"
import Notification from "./notification"
import NotificationClose from "./NotificationClose"
import NotificationDelete from "./NotificationDelete"
import NotificationError from "./NotificationError"
import Notifications from "./notifications"
import NotificationSuccess from "./NotificationSuccess"
import Off from "./off"
import OpenLink from "./openLink"
import PaperPlane from "./paper-plane"
import Paperclip from "./paperclip"
import Pictures from "./pictures"
import PiggyBank from "./piggyBank"
import PiggyBankBold from "./piggyBankBold"
import Pin from "./pin"
import PinActive from "./pinActive"
import Play from "./play"
import PluginConnect from "./pluginConnect"
import PluginConnected from "./pluginConnected"
import PluginConnectSlim from "./pluginConnectSlim"
import Plus from "./plus"
import PlusLarge from "./plusLarge"
import Processor from "./processor"
import PublicApi from "./publicApi"
import Pulse from "./pulse"
import Questionaire from "./questionaire"
import QuestionHelp from "./questionHelp"
import QuestionMarkModal from "./questionMarkModal"
import ReceiptBill from "./receiptBill"
import ReceiptCheck from "./receiptCheck"
import Currency from "./referral/currency"
import CurrencyGray from "./referral/currencyGray"
import EarningsForLife from "./referral/earningsForLife"
import JoinReferralProgram from "./referral/joinReferralProgram"
import LowerAlertCost from "./referral/lowerAlertCost"
import Megaphone from "./referral/megaphone"
import MilestoneBonuses from "./referral/milestoneBonuses"
import ReferralLink from "./referral/shareLink"
import Zap from "./referral/zap"
import Referrals from "./Referrals"
import Requests from "./requests"
import RescueRing from "./rescueRing"
import Search from "./search"
import Security from "./security"
import Send from "./send"
import Settings from "./settings"
import ShoppingAdd from "./shoppingAdd"
import Shot from "./shot"
import Alerts from "./sidebar/alerts"
//sidebar
import ArrowsOpposite from "./sidebar/arrowsOpposite"
import Centralhub from "./sidebar/centralhub"
import Developer from "./sidebar/developer"
import Google from "./sidebar/google"
import HelpCenter from "./sidebar/help_center"
import Homesidebar from "./sidebar/homesidebar"
import Integrations from "./sidebar/integrations"
import Language from "./sidebar/language"
import Referal from "./sidebar/referal"
import Supportsidebar from "./sidebar/support"
import Team from "./sidebar/team"
import Whatsap from "./sidebar/whatsap"
import Sort from "./sort"
import SortAscend from "./sortAscend"
import SortDescend from "./sortDescend"
import SparklesSoft from "./sparklesSoft"
import SquareInfo from "./squareInfo"
import SquareInfoOrange from "./squareInfoOrange"
import SquareLines from "./squareLines"
import StatsBarChart from "./statsBarChart"
import StepBack from "./stepBack"
import StripeCharged from "./stripeCharged"
import SuccessFull from "./successFull"
import Sun from "./sun"
import Support from "./support"
import SupportCircle from "./supportCircle"
import SupportFull from "./supportFull"
import ThreeDots from "./threeDots"
import TriangleExclamation from "./triangleExclamation"
import TriangleExclamation2 from "./triangleExclamation2"
import TriangleExclamationSlim from "./triangleExclamationSlim"
import TwoUsers from "./twoUsers"
import Type from "./type"
import Unarchive from "./unarchive"
import Unlockedlock from "./unlockedlock"
import User from "./user"
import UserCircle2 from "./user_circle2"
import UserSquare from "./user_square"
import UserDefault from "./user-default"
import UserAdd from "./userAdd"
import UserCircle from "./userCircle"
import Users from "./users"
import Verifi from "./verifi"
import Visa from "./visa"
import VisaLogo from "./visaLogo"
import Warning from "./Warning"
import WarningFull from "./warningFull"
import WarningOrange from "./warningOrange"
import WatchTutorial from "./watchTutorial"
import WatchVideoTutorial from "./watchVideoTutorial"
import Youtube from "./youtube"

export const svg = {
  Eye,
  EyeInvisible,
  NotificationSuccess,
  NotificationClose,
  NotificationError,
  NotificationDelete,
  Warning,
  AlertTriangleError,
  ArrowSelectDown,
  ArrowSelectDownMobile,
  CartUpcoming,
  EmptyWarning,
  Menu,
  PaperPlane,
  LogoSimple,
  UserDefault,
  Faq,
  Logout,
  Edit,
  EditSmall,
  EditBig,
  EditBig2,
  Comment,
  Moon,
  Sun,
  Copy,
  Referrals,

  ColorPalette,
  Notification,
  BulletList,

  Bank,
  PiggyBank,
  EmailNotification,
  Settings,
  Security,
  Delete,

  Sort,
  SortAscend,
  SortDescend,

  Home,
  ListSparkle,
  Requests,
  User,
  Users,
  TwoUsers,
  Notifications,
  Support,
  ChevronDownSmall,
  ChevronRightSmall,
  ChevronLeftSmall,
  CircleCheck,
  CircleCheckGreen,
  WatchTutorial,
  WatchVideoTutorial,
  CircleOutlinedInfo,

  ExclamationMarkModal,
  QuestionMarkModal,
  InfoMarkModal,

  OpenLink,

  PluginConnect,
  PluginConnectSlim,
  PluginConnected,
  CalendarClock,
  CircleX,
  CheckMark,
  Plus,
  PlusLarge,
  AddAccount,
  AddAccountDark,
  Send,

  SparklesSoft,
  QuestionHelp,
  Youtube,

  CloseModal,
  CircleInfo,
  CircleInfoSimple,
  CircleInfoStrong,
  Idea,
  CheckSimple,
  JoinReferralProgram,
  ReferralLink,
  Megaphone,
  Currency,
  CurrencyGray,
  MilestoneBonuses,
  EarningsForLife,
  LowerAlertCost,
  Zap,
  ChevronDown,
  Customers,
  ClockAlert,
  Clock,
  HourGlass,
  MastercardLogo,
  VisaLogo,
  Americanexpress,
  Discover,

  CirclePlaceholderDashed,
  CirclePlusDashed,
  Compare,
  CircleClose,
  Loader,

  CalendarDays,
  FileDownload,
  Globus,
  Business,
  Email,
  Link,
  SquareLines,
  Hashtag,
  Money,
  MoneyHand,
  Pulse,
  Processor,
  Card,
  Grab,
  UserSquare,
  UserCircle2,
  Bell,
  Message,
  PiggyBankBold,
  SquareInfo,
  ReceiptBill,
  ReceiptCheck,
  ShoppingAdd,
  ArrowRotate,
  Check,
  Verifi,
  Mastercard,
  MastercardLogoDark,
  Visa,
  FullScreen,
  ThreeDots,
  StripeCharged,
  ChargeBy,
  Logo,
  Lock,
  Unlockedlock,
  Arrows,
  InboxEmpty,
  MenuSearch,
  Search,
  CrossSmall,
  ArrowCornerDownRight,
  ArrowRight,
  ArrowLeft,
  ArrowLeft2,
  CodeLines,

  NoDataAvailable,
  BellAlarm,
  Off,
  Archive,
  Unarchive,

  Pin,
  PinActive,
  StepBack,
  UserAdd,
  ArrowsRepeat,
  ArrowInbox,
  SupportCircle,
  ArrowShareRight,
  LayoutAlignRight,

  ChecklistBell,
  HeartBeat,
  Contrast,
  TriangleExclamation,
  TriangleExclamationSlim,
  TriangleExclamation2,
  Shot,
  ArrowOutOfBox,
  Document,
  Pictures,

  Paperclip,
  UserCircle,
  CreditCard,
  MultiMedia,

  Messages,
  Camera,
  InfoBubble,

  Medal1,
  Medal2,
  Medal3,
  ArrowRisk,
  ConnectStripe,

  //sidebar
  ArrowsOpposite,
  Homesidebar,
  Alerts,
  Centralhub,
  Team,
  Integrations,
  Supportsidebar,
  HelpCenter,
  Developer,
  Language,
  Referal,
  Whatsap,
  Google,
  CheckMarkblue,
  Focus,
  Money2,
  Navigation,
  PublicApi,

  BookmarkCheck,
  Fistbump,
  Globe,
  Heart,
  MagicStick,
  Newspaper,
  SearchFindUsForm,
  SettingsGear,
  Store,
  Trophy,

  Minus,
  HelpModalError,
  ArrowsRotate,
  EyeSparkle,
  Gift,
  Grid,
  Type,
  Analytics,
  ArrowsCircle,
  InboxEmptyFilled,
  ClockOutlinedBold,
  ClockFilled,

  Play,
  RescueRing,
  SupportFull,
  CheckFull,
  EmailLarge,
  ChevronDownFull,
  WarningFull,
  AlertTransactionEdit,
  WarningOrange,
  Questionaire,
  ErrorFull,
  SuccessFull,
  InfoWarningBig,
  SuccessModal,
  ConfirmDeleteModal,
  CircleQuestion,
  SquareInfoOrange,
  InfoBanner,
  BhMetricChargeback,
  BhMetricPayment,
  BhMetricThreeDs,
  BhMetricVolume,
  BhVampCheck,
  BhVampFlag,
  BhVampLock,
  BhVampClock,
  BhVampQuestionMark,
  BhVampError,
  BarChart,
  TableView,
  CardsView,
  InfoBubbleEmpty,
  CopyRevert,
  Enlarge,

  MobileSideBar,
  MobileVideoCourse,
  StatsBarChart,
  BankCard,
  LockBlue,
  HourGlassGray
}
